/* =========================================================
   EXCELLENCE TOITURE — interactions communes
   (fichier : assets/et-base.js)
   ========================================================= */
(function () {
  if (window.__etBase) return;
  window.__etBase = true;

  var design = window.Shopify && window.Shopify.designMode;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  if (!design && !reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('et-anim');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }

  /* ---------- Apparition au défilement ---------- */
  function initReveal(root) {
    root.querySelectorAll('.et-reveal').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- En-tête : ombre au scroll + menu mobile ---------- */
  function initHeader(root) {
    root.querySelectorAll('.et-header').forEach(function (h) {
      if (h.__et) return; h.__et = true;
      function onScroll() { h.classList.toggle('is-scrolled', window.scrollY > 10); }
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      var menu = h.querySelector('.et-mmenu');
      var open = h.querySelector('.et-burger');
      if (!menu || !open) return;
      function close() { menu.classList.remove('is-open'); document.body.style.overflow = ''; open.setAttribute('aria-expanded', 'false'); }
      open.addEventListener('click', function () { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; open.setAttribute('aria-expanded', 'true'); });
      menu.querySelector('.et-mclose').addEventListener('click', close);
      menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------- Toiture interactive ---------- */
  function initRoof(root) {
    root.querySelectorAll('[data-et-roof]').forEach(function (sec) {
      if (sec.__et) return; sec.__et = true;
      var roof = sec.querySelector('.et-roof');
      var cov = sec.querySelector('.et-cov');
      var lgCov = sec.querySelector('.et-lg-cov');
      var pk = sec.querySelector('.et-pk'), pt = sec.querySelector('.et-pt'), pd = sec.querySelector('.et-pd'), pf = sec.querySelector('.et-pf');
      function facts(str) {
        pf.innerHTML = '';
        (str || '').split(',').forEach(function (f) {
          f = f.trim(); if (!f) return;
          var s = document.createElement('span'); s.textContent = f; pf.appendChild(s);
        });
      }
      function fill(k, d) { pk.textContent = k; pt.textContent = d.title; pd.textContent = d.text; facts(d.facts); }
      function clear() { roof.classList.remove('is-focus'); sec.querySelectorAll('.et-layer.is-on, .et-lg.is-on').forEach(function (e) { e.classList.remove('is-on'); }); }
      sec.querySelectorAll('.et-tab').forEach(function (t) {
        t.addEventListener('click', function () {
          sec.querySelectorAll('.et-tab').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-selected', 'false'); });
          t.classList.add('is-on'); t.setAttribute('aria-selected', 'true');
          cov.setAttribute('fill', 'url(#' + t.dataset.pattern + ')');
          if (lgCov) lgCov.style.background = t.dataset.color;
          clear(); fill(sec.dataset.matLabel || 'Matériau', t.dataset);
        });
      });
      function pick(l) {
        var src = sec.querySelector('.et-lg[data-layer="' + l + '"]');
        if (!src) return;
        roof.classList.add('is-focus');
        sec.querySelectorAll('.et-layer, .et-lg').forEach(function (e) { e.classList.toggle('is-on', e.dataset.layer === l); });
        fill(sec.dataset.layerLabel || 'Couche du toit', src.dataset);
      }
      sec.querySelectorAll('.et-layer, .et-lg').forEach(function (e) { e.addEventListener('click', function () { pick(e.dataset.layer); }); });
      var first = sec.querySelector('.et-tab');
      if (first) first.click();
    });
  }

  /* ---------- Comparateur avant / après ---------- */
  function initBA(root) {
    root.querySelectorAll('.et-ba').forEach(function (ba) {
      if (ba.__et) return; ba.__et = true;
      var before = ba.querySelector('.et-before'), bar = ba.querySelector('.et-bar'), knob = ba.querySelector('.et-knob');
      if (!before || !knob) return;
      var drag = false, pos = 50;
      function set(p) { pos = Math.max(3, Math.min(97, p)); before.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)'; bar.style.left = knob.style.left = pos + '%'; }
      function fromX(x) { var r = ba.getBoundingClientRect(); set((x - r.left) / r.width * 100); }
      knob.addEventListener('pointerdown', function (e) { drag = true; knob.setPointerCapture(e.pointerId); });
      window.addEventListener('pointermove', function (e) { if (drag) fromX(e.clientX); });
      window.addEventListener('pointerup', function () { drag = false; });
      ba.addEventListener('click', function (e) { if (!knob.contains(e.target)) fromX(e.clientX); });
      knob.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') set(pos - 5); if (e.key === 'ArrowRight') set(pos + 5); });
    });
  }

  function init(root) { root = root || document; initReveal(root); initHeader(root); initRoof(root); initBA(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
